import React from 'react'

// components
import Link from 'next/link'
import Image from 'next/image'
import { CREATORLAND_SOCIALS } from '@/shared/consts/pages'
import { ISocialPlatform } from 'interfaces'
import { IMAGE_PATHS_V2 } from '@/shared/consts/imagesPaths'

// styles
import { buttonStyle, buttonLabelDiscord } from './styles'
import { cssClass } from '@/shared/utils/styles'

const sizes = {
  small: {
    padding: '.25rem .75rem',
    borderRadius: '8px',
  },
  medium: {
    padding: '.5rem 1.5rem',
    borderRadius: '12px',
  },
}

interface Props {
  className?: string[]
  url?: string
  label?: string
  size?: keyof typeof sizes
}
export const ButtonDiscord: React.FC<Props> = ({
  className = [],
  url,
  label = 'Get discord invite',
  size = 'medium',
}) => {
  const button = (
    <button
      className={cssClass([buttonStyle.discord, ...className])}
      style={sizes[size]}
    >
      <Image
        src={IMAGE_PATHS_V2.icons.socials + 'discord-white.svg'}
        alt={ISocialPlatform.DISCORD}
        width={21}
        height={24}
      />
      <span className={buttonLabelDiscord}>{label}</span>
    </button>
  )
  if (url) {
    return (
      <Link href={url} legacyBehavior>
        <a href={url} target={'_blank'} rel="noreferrer">
          {button}
        </a>
      </Link>
    )
  }
  return <Link href={CREATORLAND_SOCIALS.discord}>{button}</Link>
}
